/**
 * Step API endpoints
 */

import { apiClient } from './client';

export interface Step {
  key: string;
  name: string;
  message_template?: string | null;
  ai_messaging: boolean;
  sequence_order?: number | null;
  type: string;
  action?: string;
  created_at: string;
}

export const stepApi = {
  /**
   * Update a step's message_template and/or ai_messaging
   */
  updateStep: async (stepUuid: string, data: {
    message_template?: string | null;
    ai_messaging?: boolean;
  }): Promise<{ output: Step }> => {
    const response = await apiClient.patch<{ output: Step }>(
      `/steps/${stepUuid}/update/`,
      data
    );
    return response.data;
  },
};

